export function getPortalName(): string {
  if (isExperienceBookingPortal()) {
    return "Experience Booking Portal";
  } else if (isResellerPortal()) {
    return "Reseller Portal";
  } else return "Portal";
}

export function isExperienceBookingPortal(): boolean {
  return window.location.hostname.includes("experiencebooking");
}

export function isResellerPortal(): boolean {
  return window.location.hostname.includes("resellerportal");
}

export function getMarketingImageUrl(): string {
  if (isExperienceBookingPortal()) {
    return "https://travelcuriousgroup.com/ebp-homepage-image";
  }
  if (isResellerPortal()) {
    return "https://travelcuriousgroup.com/rp-homepage-image";
  }
  return "";
}

export function getMarketingImageAlt(): string {
  if (isExperienceBookingPortal()) return "Experience Booking Portal Marketing";
  if (isResellerPortal()) return "Reseller Portal Marketing";
  return "";
}
